// ================= scrolltop button ==================
document.addEventListener('DOMContentLoaded', function () {
  const scrollBtn = document.querySelector('.scrolltop_btn');

  if (scrollBtn) {
    // Smooth scroll to top
    scrollBtn.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });

    // Show/hide on scroll with smooth transition
    window.addEventListener('scroll', function () {
      if (window.scrollY > 500) {
        scrollBtn.classList.add('show');
      } else {
        scrollBtn.classList.remove('show');
      }
    });
  }
});



// ================= verticle_slider =================
var swiper = new Swiper(".verticle_slider", {
  direction: "vertical",
  slidesPerView: 2.2,
  spaceBetween: 35,
  loop: true,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  speed: 3000,
  breakpoints: {
    0: {
      direction: "horizontal",
      slidesPerView: 1.4,
      spaceBetween: 15,
    },
    576: {
      direction: "horizontal",
      slidesPerView: 2,
      spaceBetween: 15,
    },
    768: {
      direction: "horizontal",
      slidesPerView: 2,
      spaceBetween: 20,
    },
    992: {
      direction: "vertical",
      slidesPerView: 2.2,
      spaceBetween: 35,
    }
  }
});



// ================= skill_slider =================
var swiper = new Swiper(".skill_slider", {
  direction: "vertical",
  slidesPerView: 4,
  spaceBetween: 7,
  loop: true,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  speed: 2000,
});



// ================= video_slider =================
var swiper = new Swiper(".video_slider", {
  slidesPerView: 4,
  spaceBetween: 30,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1.8,
      spaceBetween: 25,
    },
    576: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    992: {
      slidesPerView: 4,
    },
    1200: {
      slidesPerView: 4,
    },
  }
});

// === Function: toggle autoplay based on width ===
function handleAutoplay() {
  if (window.innerWidth <= 575) {
    if (!swiper.autoplay.running) {
      swiper.params.autoplay = {
        delay: 2500,
        disableOnInteraction: false,
      };
      swiper.autoplay.start();
    }
  } else {
    if (swiper.autoplay.running) {
      swiper.autoplay.stop();
    }
  }
}

// Run on load
handleAutoplay();

// Run on resize (debounced)
window.addEventListener("resize", handleAutoplay);




// ================= video play toggle  =================
document.addEventListener("DOMContentLoaded", function () {
  const videoItems = document.querySelectorAll(".video_item");

  videoItems.forEach(item => {
    const video = item.querySelector("video");
    const playBtn = item.querySelector(".play_btn");

    playBtn.addEventListener("click", function () {
      // Stop other videos if playing
      videoItems.forEach(otherItem => {
        const otherVideo = otherItem.querySelector("video");
        const otherBtn = otherItem.querySelector(".play_btn");
        if (!otherVideo.paused && otherVideo !== video) {
          otherVideo.pause();
          otherBtn.style.display = "block";
          otherVideo.removeAttribute("controls");
        }
      });

      video.play();
      playBtn.style.display = "none";
      video.setAttribute("controls", "true");
    });

    video.addEventListener("click", function () {
      if (!video.paused) {
        video.pause();
        playBtn.style.display = "block";
        video.removeAttribute("controls");
      }
    });

    // Auto restart on end
    video.addEventListener("ended", function () {
      video.currentTime = 0; // back to start
      video.play(); // play again
    });
  });
});




// ================= Accordion =================
const allItems = document.querySelectorAll('.accordion-item');

// Set initial state
allItems.forEach(item => {
    const body = item.querySelector('.accordion-body');
    const icon = item.querySelector('.arrow-icon');
    const header = item.querySelector('.accordion-header');
    const isOpen = item.getAttribute('data-open') === 'true';

    if (isOpen) {
        body.style.maxHeight = body.scrollHeight + "px";
        icon.style.transform = 'rotate(180deg)';
    } else {
        body.style.maxHeight = null;
        icon.style.transform = 'rotate(0deg)';
    }
});

// Toggle on click
document.querySelectorAll('.accordion-header').forEach(header => {
    header.addEventListener('click', function () {
        const currentItem = this.closest('.accordion-item');
        const currentBody = currentItem.querySelector('.accordion-body');
        const currentIcon = this.querySelector('.arrow-icon');
        const isOpen = currentItem.getAttribute('data-open') === 'true';

        // Close all
        allItems.forEach(item => {
            const body = item.querySelector('.accordion-body');
            const icon = item.querySelector('.arrow-icon');
            const header = item.querySelector('.accordion-header');

            item.setAttribute('data-open', 'false');
            body.style.maxHeight = null;
            icon.style.transform = 'rotate(0deg)';
        });

        // Open clicked
        if (!isOpen) {
            currentItem.setAttribute('data-open', 'true');
            currentBody.style.maxHeight = currentBody.scrollHeight + "px";
            currentIcon.style.transform = 'rotate(180deg)';
        }
    });
});

// Maintain height on resize
window.addEventListener("resize", () => {
    allItems.forEach(item => {
        const body = item.querySelector(".accordion-body");
        if (item.getAttribute('data-open') === 'true') {
            body.style.maxHeight = body.scrollHeight + "px";
        }
    });
});



// ======== aos animation ========
AOS.init({
  duration: 1000,
  once: false,
});


